<div class="form-container" *ngIf="ticket">
    <div class="row heading-row">
        <div class="col-4">
            <h3 class="pl-5">Ticket - {{ ticket.ticket.ticketNumber }}</h3>
        </div>
        <div *ngIf="activeUser.limited" class="col-4 text-center text-danger">
            <h1>Read Only</h1>
        </div>
        <div class="col text-right">
            <button *ngIf="!activeUser.limited" mat-raised-button color="primary" class="submit-note-btn mr-3"
                    [disabled]="ticket.ticket.title === ticketService.selectedTicket.value.ticket.title"
                    (click)="saveTicket()">Save Ticket</button>
            <button mat-raised-button color="accent" class="mr-5" (click)="ticketService.backToTicketList()">Back</button>
        </div>
    </div>


    <div class="row content-area">
        <mat-card class="col-12">
            <mat-card-header>
                <mat-card-title>Basic Information</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="row">
                    <mat-form-field class="col-lg-8">
                        <mat-label>Ticket Title</mat-label>
                        <input matInput type="text" class="ticket-title" [(ngModel)]="ticket.ticket.title" [disabled]="ticket.ticket.status !== 'O' || activeUser.limited" required />
                    </mat-form-field>
                    <mat-form-field class="col-lg-2">
                        <mat-label>Credit Union</mat-label>
                        <input matInput type="text" [(ngModel)]="ticket.ticket.requestedFor" class="requested-by" [disabled]="true" readonly/>
                    </mat-form-field>
                    <mat-form-field class="col-lg-2">
                        <mat-label>Ticket Type</mat-label>
                        <input matInput type="text" [value]="ticketService.getTicketType(ticket.ticket.ticketType)" [disabled]="true" readonly>
                    </mat-form-field>
                    <mat-form-field class="col-lg-5">
                        <mat-label>Support Representative</mat-label>
                        <input matInput type="text"
                               [ngModel]="(ticket.ticket.supportRepresentative | toName: (allPortalUsers | async)) || 'No Support Rep Assigned'"
                               [disabled]="true"
                               readonly>
                    </mat-form-field>
                    <mat-form-field class="col-lg-2">
                        <mat-label>Opened</mat-label>
                        <input matInput type="text" [ngModel]="ticket.ticket.createdTime | date: 'MM/dd/yyyy'" [disabled]="true" readonly>
                    </mat-form-field>
                    <mat-form-field class="col-lg-2">
                        <mat-label>Percent Complete</mat-label>
                        <input matInput type="text" [ngModel]="ticket.ticket.percentComplete" [disabled]="true" readonly>
                        <span matSuffix>%</span>
                    </mat-form-field>

                    <div class="col-lg text-center" *ngIf="!activeUser.limited">
                        <button *ngIf="!ticketService.isTicketOpen(); else openTicket"
                                mat-raised-button
                                color="warn"
                                class="close-btn"
                                (click)="closeRequestDialog()"
                                [disabled]="ticketService.isTicketOpen()">Close Ticket</button>
                        <ng-template #openTicket>
                            <button mat-raised-button
                                    color="primary"
                                    class="open-btn"
                                    (click)="requestToOpenDialog()"
                                    [disabled]="!ticketService.isTicketOpen()">Open Ticket</button>
                        </ng-template>
                    </div>

<!--                     TODO: THIS IS COMMENTED OUT AS THERE IS NO WAY TO GET THE CURRENT POINTS ON THE TICKET               -->

<!--                    <mat-card *ngIf="ticket.ticket.ticketType === 'C'" class="col-6 community-points">-->
<!--                        <mat-card-header>-->
<!--                            <mat-card-title>Community Points</mat-card-title>-->
<!--                        </mat-card-header>-->
<!--                        <mat-card-content>-->
<!--                            <div class="row">-->
<!--                                <div class="col">-->
<!--                                    <div class="text-center">-->
<!--                                        <h4 style="padding-top: 41px">Ticket Points: {{totalCommunityPoints}}</h4>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col text-center">-->
<!--                                    <p class="text-left text-muted" style="padding-left: 15px">Available Points: {{availablePoints}}</p>-->
<!--                                    <div class="row">-->
<!--                                        <h4 class="point-display">Add Points:</h4>-->
<!--                                        <button mat-icon-button class="pointBtn dec-btn" (click)="decreasePoints()"><i class="fa fa-minus"></i></button>-->
<!--                                        <input matInput type="text" readonly [(ngModel)]="addedPoints" class="point-input">-->
<!--                                        <button mat-icon-button color="primary" class="pointBtn inc-btn" (click)="increasePoints()"><i class="fa fa-plus"></i></button>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </mat-card-content>-->
<!--                    </mat-card>-->
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="row content-area">
        <mat-card class="col-12">
            <mat-card-header>
                <mat-card-title>Notes</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="note-card">
                    <ng-container *ngFor="let note of ticketService.selectedTicket.value.notes">
                        <div class="card" *ngIf="!note.privateNote">
                            <div class="card-header">
                                <i class="far fa-comment"></i>  {{note.createdBy}} - {{note.lastUpdated | date}}
                            </div>
                            <div class="card-body">
                                <p class="card-text">{{note.note}}</p>
                            </div>
                        </div>
                    </ng-container>
                    <div class="card new-note" *ngIf="!activeUser.limited">
                        <div class="card-header">
                            <i class="far fa-comment"></i>  {{activeUser.firstName + ' ' + activeUser.lastName}}- {{ today | date}}
                        </div>
                        <div class="card-body">
                            <mat-form-field class="col" floatLabel="always">
                                <mat-label></mat-label>
                                <textarea class="ticket-notes" rows="10" cols="100" style="resize: none" matInput type="text"
                                          [(ngModel)]="newNote" placeholder="Enter your notes here..." [disabled]="ticketService.isTicketOpen()"></textarea>
                            </mat-form-field>
                        </div>
                        <div class="card-footer text-right">
                            <button *ngIf="!activeUser.limited" mat-raised-button color="primary" class="submit-note-btn text-right"
                                    (click)="saveTicket()" [disabled]="!newNote">Save</button>
                            <button mat-raised-button class="cancel-btn text-right" (click)="ticketService.backToTicketList()">Cancel</button>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="row content-area" *ngIf="!activeUser.limited">
        <mat-card class="col-12">
            <mat-card-header>
                <mat-card-title>Attachments</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="row" *ngIf="ticketService.selectedTicketAttachments | async">
                    <div class="col text-center">
                        <mat-chip-list class="d-flex justify-content-center m-3">
                            <mat-chip class="download-chips" color="primary" *ngFor="let attachment of ticketService.selectedTicketAttachments | async"
                                      (click)="ticketService.downloadAttachment(attachment.fileName)">
                                {{attachment.fileName}}
                                <mat-icon>file_download</mat-icon>
                            </mat-chip>
                        </mat-chip-list>
                    </div>
                </div>
                <div class="row" *ngIf="ticket.ticket.status === 'O'">
                    <div class="col text-center">
                        <button class="mb-3" mat-raised-button color="primary" (click)="selectFiles()">
                            Select Files
                        </button>
                        <p class="text-muted">Supported file types: .jpg, .pdf, .png, .txt</p>
                        <p class="text-muted"><i>Max file size: 5MB</i></p>
                    </div>
                    <div class="col-12">
                        <mat-chip-list *ngIf="ticketService.attachmentsToUpload.length > 0" class="d-flex justify-content-center mb-3">
                            <mat-chip *ngFor="let file of ticketService.attachmentsToUpload; let i = index"
                                      (removed)="removeAttachmentFromList(i)">
                                {{file.fileName}}
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip>
                        </mat-chip-list>
                    </div>
                </div>
                <div class="card-footer text-right" *ngIf="ticket.ticket.status === 'O'">
                    <button *ngIf="!activeUser.limited" mat-raised-button color="primary" class="submit-note-btn text-right"
                            [disabled]="ticketService.attachmentsToUpload.length === 0"
                            (click)="saveTicket()">
                        Save Ticket
                    </button>
                    <button mat-raised-button class="cancel-btn text-right" (click)="ticketService.backToTicketList()">Cancel</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
